<template>
  <div class="mask" :style="{zIndex:zIndex}" @click="handleClick" @touchmove="handleTouchmove"></div>
</template>

<script>
export default {
  name: "vmask",
  props: {
    zIndex: {
      type: Number,
      default: 300,
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
    handleTouchmove(e) {
      this.$emit("touchmove", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  overflow-x: hidden;
  overflow-y: hidden;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
</style>